module.exports = __webpack_public_path__ + "img/yan.c40ab68f.png";